/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import cx from 'classnames';
import React from 'react';

import { RESPONSE_PROPERTY, REQUIRED, OPTIONAL } from './constants';

interface PropertyComponentProps {
  /**
   *
   */
  type: string;
  /**
   *
   */
  isNestedObj: boolean;
  /**
   *
   */
  row: any;
  /**
   *
   */
  name: string;
  /**
   *
   */
  propIndex: number;
  /**
   *
   */
  responseType: string;
  /**
   *
   */
  required: boolean;
}
export const PropertyComponent = ({
  type,
  isNestedObj,
  row,
  name,
  propIndex,
  responseType,
  required
}: PropertyComponentProps) => {
  const divKey = isNestedObj
    ? `${row.id}-response-${propIndex}-object-${name}`
    : `${row.id}-response-${propIndex}`;

  return (
    <div
      key={divKey}
      className={cx({
        'CatalogOpenApiDataTable__operation-params-and-responses-item': true
      })}>
      <div className="CatalogOpenApiDataTable__operation-params-and-responses-item">
        {name !== undefined && name !== '' && (
          <div className="CatalogOpenApiDataTable__operation-params-and-responses-item-title CatalogOpenApiDataTable__operation-params-and-responses-indentedTitle">
            {name}
          </div>
        )}
        <div
          className={cx({
            'CatalogOpenApiDataTable__operation-params-and-responses-item-subtitle':
              true,
            CatalogOpenApiDataTable__arrayResponse:
              name === undefined || name === ''
          })}>
          {type === RESPONSE_PROPERTY
            ? responseType
            : `${responseType} | ${required ? REQUIRED : OPTIONAL}`}
        </div>
      </div>
    </div>
  );
};

export default PropertyComponent;
